var React = require('react');

function Lollipop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z","stroke":"#343434","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.0762 22.1518V12.9238","stroke":"#343434","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Lollipop.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Lollipop;

Lollipop.default = Lollipop;
